import "./termsConditions.css";
import Header from '../shared/header/header';
import React, { useRef, useState, useEffect } from 'react';
import Footer from '../shared/footer/footer';
import useGetdata from '../../Hooks/useGetData';
import { useSelector } from 'react-redux';
import SnackbarNav from '../main/SnackbarNav/SnackbarNav';
import MobileMenu from '../main/SnackbarNav/MobileMenu';

const sections = [
  {
    id: "acceptance",
    title: "Acceptance of Terms",
    type: "text",
    content: [
      `By accessing, browsing, or using the Skye Air Mobility website or any
associated mobile application, you acknowledge that you have read, understood,
and agree to be bound by these Terms and Conditions (“Terms”), along with our
Privacy Policy and any other policies referenced herein. If you do not agree to these
Terms, please discontinue use of our services immediately.
`,
      `Skye Air Mobility reserves the right to update, modify, or replace any part of these
Terms at any time. Continued use of the platform following the posting of changes
constitutes acceptance of those charges.`]

  },
  {
    id: "about",
    title: "About Skye Air Mobility",
    type: "text",
    content: [
      `Skye Air Mobility is a drone logistics and urban air mobility company incorporated
under the laws of India, providing last-mile delivery solutions, aerial surveys, and
mobility services using unmanned aerial vehicles (UAVs/Drones).
`,
      `Our operations are
governed by applicable regulations of the Directorate General of Civil Aviation
(DGCA) and other relevant statutory bodies.
The website may display information about Skye Air Mobility’s business clients,
institutional partners, and program participants for the purposes of transparency
and commercial communication. Such disclosure are made with the prior consent of
the relevant parties and governed by applicable confidentiality agreements.`]

  },
  {
    id: "eligibility",
    title: "Eligibility & User Obligations",
    type: "list",
    content: `You must be at least 18 years of age and legally capable of entering into binding
contracts under Indian law to use our services. By using our platform, you represent
and warrant that:`,
    points: [
      "Autonomous drone-based package delivery",
      "Real-time shipment tracking and notifications",
      "Skye UTM (Unmanned Traffic Management) Platform",
      "AI-powered route optimization and delivery scheduling",
    ],
  },

  {
    id: "services-offered",
    title: "Services Offered",
    type: "list-with-footer",
    content:
      "Skye Air Mobility offers the following categories of services, subject to availability and regulatory approval:",
    points: [
      {
        label: "Drone Delivery Services",
        desc: "Last-mile delivery of goods, medicine, and parcels via UAVs."
      },
      {
        label: "Aerial Survey &amp; Inspection",
        desc: "Agricultural, Infrastructure, and topographic survey services."
      },
      {
        label: "Technology Solutions",
        desc: " Fleet management, UTM (Unmanned Traffic Management) software, and data analytics."
      },
      {
        label: "Partnership Services",
        desc: "Co-branded and API- Integrated logistics solutions for partners."
      }
    ],
    footer:
      "All services are subject to regulatory approvals, operational zones, payload limitations, and weather conditions. Skye Air Mobility reserves the right to modify or discontinue any service at any time."
  },
  {
    id: "cod-terms",
    title: "Cash On Delivery (COD) Deposit Portal – Terms Of Use",
    type: "mixed",
    content: [
      "The website hosts a COD Deposit Portal (“Portal”) through which authorised delivery personnel—including Skye Air Mobility employees, franchise partners, and contracted third-party delivery riders (“Riders”), may deposit cash on delivery amounts collected during deliveries."
    ],
    items: [
      {
        title: "Authorised access",
        content: [
          "The Portal is accessible exclusively to persons formally onboarded by Skye Air Mobility or an authorized partner.",
          "Unauthorised access or misuse constitutes a violation of these Terms and may result in legal action under the Information Technology Act, 2000 and applicable criminal law."
        ]
      },
      {
        title: "Nature of Transactions",
        content: [
          "All deposits represent the transfer of COD amounts collected on behalf of Skye Air Mobility or its clients.",
          "By initiating a deposit, a Rider confirms that:"
        ],
        points: [
          "The amount deposited accurately reflects cash collected for the designated delivery.",
          "The deposit is made in good faith and free from fraud, misrepresentation, or shortfall.",
          "They are the authorised Rider for the corresponding delivery assignment.",
          "Any discrepancy between the amount due and deposited will be reported immediately."
        ]
      },
      {
        title: "Payment Gateway Provider",
        content: [
          "COD deposits are processed through a third-party payment gateway integrated into the Portal.",
          "Skye Air Mobility does not store payment instrument data (UPIs, bank credentials, or card details) on its own servers.",
          "All financial transactions are handled in compliance with RBI guidelines and applicable laws."
        ]
      },
      {
        title: "Reconciliation and Accountability",
        content: [
          `All deposits are subject to reconciliation against delivery records in Skye Air
Mobility’s operations system. Discrepancies including shortfalls, excess
deposits, or duplicate payments shall be resolved per the applicable Rider agreement or franchise terms. Skye Air Mobility may deduct unreconciled
amounts from future settlements or take appropriate remedial action`
        ]
      },
      {
        title: "Prohibited Conduct",
        content: [
          "The following are strictly prohibited and may result in termination of access, recovery proceedings, and legal action:"
        ],
        points: [
          "Depositing amounts not linked to actual deliveries.",
          "Misrepresenting delivery completion to trigger deposit obligations",
          "Initiating fraudulent or test transaction with unauthorised persons.",
          "Sharing portal access credentials with unauthorised persons.",
          "Attempting to reverse or chargeback legitimate COD deposits."
        ]
      },
      {
        title: "Information Collected from Website Visitors",
        content: [
          `Visitors may submit information through enquiry forms, newsletter subscriptions,
and partner interest forms. By doing so, you confirm that the information is
accurate, that you are authorised to share any business details provided, and that
you consent to Skye Air Mobility, contacting you in connection with your
submission.`,
          `Skye Air Mobility does not send unsolicited commercial communications.
Subscribers may unsubscribe at any time. Enquiry data is returned for up to 24
months unless an ongoing business relationship is established, where upon our
standard retention policy applies full details are in the privacy policy.`
        ]
      },
      {
        title: "Intellectual Property Rights",
        content: [
          `All website content, including text, graphics, logos, interface, designs, and data
complications is owned by Skye Air Mobility are used under license. You may not
reproduce, distribute, or creative derivative works without prior return permission.`,
          `Limited, personal, non-commercial use is permitted where it does not harm the
commercial interest of Skye Air Mobility or its clients.`
        ]
      },
      {
        title: "Limitation of Liability",
        content: [
          `Skye Air Mobility shall not be liable for any indirect, incidental or consequential
damages arising from the use of this website or the portal. We do not warrant
uninterrupted or error free access to the portal and expressly disclaim liability for
losses from Gateway down or force majeure events.`
        ]
      },

      {
        title: "Governing Law and Dispute Resolution",
        content: [
          `These terms are governed by the laws of India. Disputes are subject to the
exclusive jurisdiction of courts in New Delhi, India. Prior to litigation, both parties
agree to attempt good faith resolution within 30 days, unresolved disputes shall be
referred to arbitration under the arbitration and conciliation act, 1996..`
        ]
      },
    ]
  },
];

const Terms = () => {
  const sectionRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 480);
  const data = useSelector((store) => store.data.HomeData);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 480);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useGetdata();

  useEffect(() => {
    const handleScroll = () => {
      const links = document.querySelectorAll(".nav-link");
      sections.forEach((sec) => {
        const el = document.getElementById(sec.id);
        if (!el) return;
        const rect = el.getBoundingClientRect();
        if (rect.top <= 150 && rect.bottom >= 150) {
          links.forEach((l) => l.classList.remove("active"));
          document.querySelector(`[data-link="${sec.id}"]`)?.classList.add("active");
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="terms-page-wrapper">
      <div ref={sectionRef} className="contact-container">
        <div className="terms-home-container">
          <Header />
        </div>
      </div>

      <div className="terms-page">
        <div className="terms-hero">
          <div className="overlay">
            <p className="breadcrumb">LEGAL / POLICIES</p>
            <h1>Terms & Conditions</h1>
            <p className="subtitle">
              Please read these terms carefully before using our services.
            </p>
            <p className="last-updated" style={{ fontSize: '0.8rem', marginTop: '10px', opacity: 0.7 }}>
              Last Updated: March 26, 2026
            </p>
          </div>
        </div>

        <div className="terms-body">
          {!isMobile && (
            <div className="terms-sidebar">
              <p className="sidebar-title">QUICK NAVIGATION</p>
              {sections.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  data-link={item.id}
                  className="nav-link"
                >
                  {item.title}
                </a>
              ))}
            </div>
          )}

          <div className="terms-content">
            {sections.map((sec) => (
              <section key={sec.id} id={sec.id}>
                <h2>{sec.title}</h2>
                <hr className="section-divider" />

                {sec.type === "text" && (
                  <>
                    {Array.isArray(sec.content) ? (
                      sec.content.map((p, i) => (
                        <p key={i} style={{ marginBottom: "15px" }}>{p}</p>
                      ))
                    ) : (
                      <p>{sec.content}</p>
                    )}
                  </>
                )}

                {sec.type === "list" && (
                  <>
                    <p>{sec.content}</p>
                    <ul className="blue-bullet-list">
                      {sec.points.map((point, i) => (
                        <li key={i}>{point}</li>
                      ))}
                    </ul>
                  </>
                )}

                {sec.type === "subsections" && (
                  <div className="subsections-wrapper">
                    {sec.items.map((item, i) => (
                      <div key={i} className="subsection">
                        <h4>{item.title}</h4>
                        <p>{item.content}</p>
                      </div>
                    ))}
                  </div>
                )}

                {sec.type === "mixed" && (
                  <>
                    {sec.content?.map((p, i) => (
                      <p key={i} style={{ marginBottom: "15px" }}>{p}</p>
                    ))}

                    {sec.items?.map((item, i) => (
                      <div key={i} className="subsection">
                        <h4>{item.title}</h4>

                        {item.content?.map((p, j) => (
                          <p key={j}>{p}</p>
                        ))}

                        {item.points && (
                          <ul className="blue-bullet-list">
                            {item.points.map((point, k) => (
                              <li key={k}>{point}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </>
                )}

                {sec.type === "list-with-footer" && (
                  <>
                    <p>{sec.content}</p>

                    <ul className="blue-bullet-list">
                      {sec.points.map((item, i) => (
                        <li key={i}>
                          <strong>{item.label}:</strong> {item.desc}
                        </li>
                      ))}
                    </ul>

                    {sec.footer && <p className="policy-footer">{sec.footer}</p>}
                  </>
                )}

              </section>
            ))}
          </div>
        </div>
      </div>
      <Footer />

      <section>
        {!isMobile && <SnackbarNav />}
        {isMobile && !menuOpen && (
          <button className="menu-toggle" onClick={() => setMenuOpen(true)}>
            ☰
          </button>
        )}
        {isMobile && menuOpen && (
          <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
        )}
      </section>
    </div>
  );
};

export default Terms;